import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-page-skeleton-loader',
  templateUrl: './contact-page-skeleton-loader.component.html',
  standalone: false,
})
export class ContactPageSkeletonLoaderComponent {}
